export const types = {
	login: '[Auth] Login',
	logout: '[Auth] Logout',
	dark: '[Ui] Dark',
	ligth: '[Ui] Ligth',
	setAny: '[Ui] Set Any',
};
